var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProfilechat = function SvgProfilechat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M10.666 21.004 12 19.67l-1.334-1.333M20.892 14.007a2.336 2.336 0 0 1 1.111 1.773c0 1.636-2.6 3.034-6.28 3.61"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M3.106 14.007a2.336 2.336 0 0 0-1.112 1.773c0 2.149 4.479 3.89 10.004 3.89"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M15.42 14.038H8.58a.583.583 0 0 1-.582-.581v-.473a2.441 2.441 0 0 1 2.433-2.434h3.137a2.441 2.441 0 0 1 2.433 2.434v.473a.583.583 0 0 1-.58.58M12 7.645a2.325 2.325 0 1 1-.002-4.65A2.325 2.325 0 0 1 12 7.645",
    clipRule: "evenodd"
  })));
};
export { SvgProfilechat as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiN2RlNGIwYzMwYjQ0MmJmM2QwZGZiYjczYjNkYzNhNDkuc3ZnIjs=";